import * as React from 'react';
import { cn } from '@/shared/utils/cn';
import { GameCardUIStar } from '@/features/games/shared/components/game-card-ui-star';

type RatingStarsProps = {
  value: number;
  size?: number;
  className?: string;
  showValueText?: boolean;
};

export function GameCardUIRating({
  value,
  size = 20,
  className,
  showValueText = false,
}: RatingStarsProps) {
  const v = Math.max(0, Math.min(5, value || 0));
  const fills = Array.from({ length: 5 }, (_, i) => {
    const starValue = v - i;
    if (starValue >= 1) return 100;
    if (starValue <= 0) return 0;
    return Math.round(starValue * 100);
  });

  return (
    <div
      className={cn('flex items-center gap-1 text-white', className)}
      role='img'
      aria-label={`Rating: ${v.toFixed(1)} out of 5`}
      title={`${v.toFixed(1)} / 5`}
    >
      {fills.map((pct, i) => (
        <GameCardUIStar key={i} fillPct={pct} size={size} />
      ))}
      {showValueText && <span className='ml-1 text-sm text-white/90'>{v.toFixed(1)}</span>}
    </div>
  );
}
